import type {
  TrustedRefereeMeeting,
  TrustedRefereeMeetingVariables,
  // eslint-disable-next-line import/no-restricted-paths
} from "business_portal/trusted_referee/meeting/index.graphql";
import { createMeetingContext } from "common/meeting/context";

import type { TrustedRefereeMeetingAnalytics } from "../analytics";

const { useMeetingContext, MeetingContextProvider } = createMeetingContext<
  TrustedRefereeMeeting,
  TrustedRefereeMeetingVariables,
  TrustedRefereeMeetingAnalytics
>();

export const TrustedRefereeNotaryMeetingProvider = MeetingContextProvider;
export const useTrustedRefereeNotaryMeetingContext = useMeetingContext;
